__turbopack_context__.v({
  "auto": "modal-module-scss-module__U-5OcW__auto",
  "bottom": "modal-module-scss-module__U-5OcW__bottom",
  "close": "modal-module-scss-module__U-5OcW__close",
  "container": "modal-module-scss-module__U-5OcW__container",
  "container-in": "modal-module-scss-module__U-5OcW__container-in",
  "container-out": "modal-module-scss-module__U-5OcW__container-out",
  "full": "modal-module-scss-module__U-5OcW__full",
  "header": "modal-module-scss-module__U-5OcW__header",
  "modal": "modal-module-scss-module__U-5OcW__modal",
  "modal-in": "modal-module-scss-module__U-5OcW__modal-in",
  "modal-out": "modal-module-scss-module__U-5OcW__modal-out",
  "title": "modal-module-scss-module__U-5OcW__title",
  "transition": "modal-module-scss-module__U-5OcW__transition",
});
